import type { ModulationLocationContractReportSchema } from '@libs/data-access/entities'

import { httpServices } from '../../../apis'
import type { QueryFnParams } from '../../../types'

/**
 * Fetch Modulation Location Report
 */

export type FetchModulationPayrollReportOptions = QueryFnParams<{
  pathParams: { report_id: number }
}>

export const fetchModulationPayrollReport = async (
  opts: FetchModulationPayrollReportOptions
) => {
  const response = await httpServices.core.get<
    ModulationLocationContractReportSchema[]
  >(`/reports/${opts?.pathParams.report_id}/modulation_report`)
  return response.data
}
